export const T = {
  en_GB: {
    addCustomInstument: "Add Custom Instrument",
    // Delete
    deleteInstrument: "Delete Custom Instrument",
    deleteInstrumentDescription:
      "Are you sure you want to delete this custom instrument? This action cannot be undone.",
    delete: "Delete",
    cancel: "Cancel",
    // Alerts
    error: "Error",
    instrumentDeletedSuccess: "Custom instrument deleted successfully.",
    failedToDeleteInstrument: "Failed to delete custom instrument.",
    instrumentInUse: "This instrument cannot be deleted because it is in use:",
    usedByCombined: "Combined instruments: ",
    usedByProducts: "Portfolio products: ",
  },
  nb_NO: {
    addCustomInstument: "Legg til egendefinert instrument",
    // Delete
    deleteInstrument: "Slett egendefinert instrument",
    deleteInstrumentDescription:
      "Er du sikker på at du vil slette dette egendefinerte instrumentet? Denne handlingen kan ikke angres.",
    delete: "Slett",
    cancel: "Avbryt",
    // Alerts
    error: "Feil",
    instrumentDeletedSuccess: "Egendefinert instrument slettet.",
    failedToDeleteInstrument: "Kunne ikke slette egendefinert instrument.",
    instrumentInUse: "Dette instrumentet kan ikke slettes fordi det er i bruk:",
    usedByCombined: "Kombinerte instrumenter: ",
    usedByProducts: "Porteføljeprodukter: ",
  },
} as const;
